import { IUser, IUserCommon } from '../../../shared/types/user';
import { ROLES } from '../../permissions/permissions';

export function isAdminOrModerator({ roles }: IUser | IUserCommon): boolean {
  return (roles || []).some(role => role === ROLES.admin || role === ROLES.moderator);
}
